import {LOGIN, LOGOUT, REGISTER, SET_CURRENT_COMPANY} from '../types/index'
import FirebaseService from '../../services/firebaseService'

export const register = (params, history) => dispatch => {
    return FirebaseService.register(params)
        .then(data => {
            dispatch({type: REGISTER, payload: data})
            history.push('/dashboard')
        })
        .catch(err => {
            throw err
        })
}

export const registerWithCompany = (params, history) => dispatch => {
    return FirebaseService.registerWithCompany(params)
        .then(data => {
            dispatch({type: REGISTER, payload: data})
            history.push('/dashboard')
        })
        .catch(err => {
            throw err
        })
}

export const login = (params, history) => dispatch => {
    return FirebaseService.login(params)
        .then(data => {
            dispatch({type: LOGIN, payload: data})
            history.push('/dashboard')
        })
        .catch(err => {
            throw err
        })
}

export const autoLogin = () => dispatch => {
    return FirebaseService.autoLogin()
        .then(data => {
            dispatch({type: LOGIN, payload: data})
        })
        .catch(err => {
            dispatch({type: LOGOUT})
            throw err
        })
}

export const autoLoginTest = user => dispatch => {
    return FirebaseService.autoLoginTest(user)
        .then(data => {
            dispatch({type: LOGIN, payload: data})
        })
        .catch(err => {
            dispatch({type: LOGOUT})
            throw err
        })
}

export const logout = (history) => dispatch => {
    return FirebaseService.logout()
        .then(res => {
            dispatch({type: LOGOUT})
            history.push('/')
        })
        .catch(err => {
            throw err
        })
}

export const setCurrentCompany = company => dispatch => {
    dispatch({type: SET_CURRENT_COMPANY, payload: company})
}
